import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { loadGoogleMaps } from "./utils/maps/load-google-maps";

if (process.env.IS_DEV) {
  import("eruda").then((eruda) => eruda.default.init());
}

loadGoogleMaps().then(() => {
  ReactDOM.render(<App />, document.getElementById("root"));
});
